import { PropsType } from "../../../../lib/Props";
export const sliderRendererOptionsType = new PropsType({
    description: true,
    disabled: true,
    dragAndClickDisabled: true,
    from: true,
    onBlur: true,
    onChange: true,
    onFocus: true,
    onMove: true,
    to: true,
    steps: true,
    value: true,
    sliderController: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9TbGlkZXIvaG9va3MvdXNlU2xpZGVyUmVuZGVyZXIvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBa0lsRCxNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxJQUFJLFNBQVMsQ0FBd0I7SUFDNUUsV0FBVyxFQUFFLElBQUk7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxvQkFBb0IsRUFBRSxJQUFJO0lBQzFCLElBQUksRUFBRSxJQUFJO0lBQ1YsTUFBTSxFQUFFLElBQUk7SUFDWixRQUFRLEVBQUUsSUFBSTtJQUNkLE9BQU8sRUFBRSxJQUFJO0lBQ2IsTUFBTSxFQUFFLElBQUk7SUFDWixFQUFFLEVBQUUsSUFBSTtJQUNSLEtBQUssRUFBRSxJQUFJO0lBQ1gsS0FBSyxFQUFFLElBQUk7SUFDWCxnQkFBZ0IsRUFBRSxJQUFJO0NBQ3ZCLENBQUMsQ0FBQyJ9